<div class="footer-content" [ngStyle]="{'color': textColor}" *ngIf="show">
    &copy;Stonwerk 2023 <br>
    Patent Pending
</div>
